import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OEIconCodes from '../../../../lib/oe-icon-codes';
import OEIcon from '../../../elements/oe-icon';
import OEFNElement from '../../../elements/oe-flow-nav-elements';
import {OEFNStartSelectionModel, OEFNStartSelectionPropTypes} from './oe-fn-start-selection-model';
import {OEFNStartSelectionCurrentItemTitle} from './oe-fn-start-selection-current-item-title';

export class OEFNStartSelectiontCurrentItemTitleLabel extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            strings: {
                currentChoice:  'current'
            },
            title:              ''
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.ontItemTitleChanged = this.ontItemTitleChanged.bind(this);
    }

    componentWillReceiveProps(nextProps)   {
        if(nextProps.locStringPrefix !== this.props.locStringPrefix)  {
            this.updateLanguage(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateLanguage(props)   {
        if(!this.oe.isReady())  return;
        props = props || this.props;
        let si = this.oe.sharedInterface;

        this.setState({strings: {
            currentChoice: si.getLocalizedStringEnc(props.locStringPrefix + 'start_selection_view_current_choice')
        }});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <OEFNStartSelectionCurrentItemTitle
                    moduleId={this.props.moduleId}
                    target={this.props.target}
                    content={this.props.content}
                    onTitleChanged={this.ontItemTitleChanged}
                />

                {!this.state.title ? null :
                    <React.Fragment>
                        <OEFNElement.Block className="current-choice" content={this.state.strings.currentChoice + ': ' + this.state.title}/>
                        <OEFNElement.Spacer height="1.375em" /*22px*//>
                    </React.Fragment>
                }
            </React.Fragment>
        );
    }

    ontItemTitleChanged(sender, title)    {
        if(this.props.ontItemTitleChanged)  this.props.ontItemTitleChanged(this, title);
        this.setState({title: title});
    }
}

OEFNStartSelectiontCurrentItemTitleLabel.defaultProps = {
    moduleId:               '',
    target:                 '',
    locStringPrefix:        '',
};

OEFNStartSelectiontCurrentItemTitleLabel.propTypes = {
    moduleId:               PropTypes.string,
    target:                 PropTypes.string,
    locStringPrefix:        PropTypes.string,
    content:                OEFNStartSelectionPropTypes.content,
    ontItemTitleChanged:    PropTypes.func
};

//
export class OEFNStartSelectionModuleBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.onItemClick = this.onItemClick.bind(this);
    }

    render()    {
        if(!this.props.modules) return null;

        let items = this.props.modules.map((module, index) => {
            return {
                icon: module.icon,
                label: OEFNStartSelectionModel.unpackLabel(module.label, this.props.strings),
                disabled: module.disabled,
                content: index === this.props.selected ? <OEIcon className="selection-caret" code={OEIconCodes.caretRight}/> : null
            };
        });

        return <OEFNElement.SelectionBar className="module-selection-bar" items={items} selected={this.props.current} disabled={this.props.disabled} onItemClick={this.onItemClick}/>;
    }

    onItemClick(sender, index)    {
        if(this.props.onItemClick)  this.props.onItemClick(this, index);
    }
}

OEFNStartSelectionModuleBar.defaultProps = {
    disabled:               false
};

OEFNStartSelectionModuleBar.propTypes = {
    disabled:               PropTypes.bool,
    strings:                PropTypes.object,
    modules:                OEFNStartSelectionPropTypes.modules,
    selected:               PropTypes.number,
    current:                PropTypes.number,
    onItemClick:            PropTypes.func
};

//
export class OEFNStartSelectionCategoryBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.onItemClick = this.onItemClick.bind(this);
    }

    render()    {
        if(!this.props.categories) return null;

        let items = this.props.categories.map((category) => {
            return {
                label:      OEFNStartSelectionModel.unpackLabel(category.label, this.props.strings),
                disabled:   module.disabled
            };
        });

        return <OEFNElement.SelectionBar className="category-selection-bar" items={items} selected={this.props.selected} disabled={this.props.disabled} onItemClick={this.onItemClick}/>;
    }

    onItemClick(sender, index)    {
        if(this.props.onItemClick)  this.props.onItemClick(this, index);
    }
}

OEFNStartSelectionCategoryBar.defaultProps = {
    disabled:               false
};

OEFNStartSelectionCategoryBar.propTypes = {
    disabled:               PropTypes.bool,
    strings:                PropTypes.object,
    categories:             OEFNStartSelectionPropTypes.categories,
    selected:               PropTypes.number,
    onItemClick:            PropTypes.func
};

//
export class OEFNStartSelectionCategory extends React.PureComponent {

    constructor(props) {
        super(props);

        this.onItemClick = this.onItemClick.bind(this);
        this.onDisabledItemClick = this.onDisabledItemClick.bind(this);
    }

    render()    {
        if(!this.props.category || !Array.isArray(this.props.category.subcategories))   return null;

        let elements = [];
        let key = 0;

        if(this.props.categoryLabel)   {
            let label = OEFNStartSelectionModel.unpackLabel(this.props.category.label, this.props.strings);
            if(label)   ret.push(<OEFNElement.Block key={key++} className="category" content={label}/>);
        }

        let visibleCategory = 0;

        this.props.category.subcategories.forEach(subcategory => {
            let label = OEFNStartSelectionModel.unpackLabel(subcategory.label, this.props.strings);

            if(label)   {
                if(visibleCategory) elements.push(<OEFNElement.Spacer key={key++} height="1em" /*16px*//>);
                visibleCategory++;
                elements.push(<OEFNElement.Block key={key++} className="subcategory" content={OEFNStartSelectionModel.unpackLabel(subcategory.label, this.props.strings)}/>);
                if(!Array.isArray(subcategory.items))   return;
                elements.push(<OEFNElement.Spacer key={key++} height="1em" /*16px*//>);
            } else {
                if(!Array.isArray(subcategory.items) || !subcategory.items.length)   return;
                if(visibleCategory) {
                    elements.push(<OEFNElement.Spacer key={key++} height="0.875em" /*14px*//>);
                    elements.push(<OEFNElement.Separator key={key++} className="subcategory-separator"/>);
                    elements.push(<OEFNElement.Spacer key={key++} height="0.875em" /*14px*//>);
                }
                visibleCategory++;
            }
 
            subcategory.items.forEach((item, index, items) => {
                elements.push(
                    <OEFNElement.Block
                        key={key++}
                        id={item.target}
                        className={'item' + (index === items.length - 1 ? ' last' : '') + (item.target === this.props.target ? ' current' : '') + (item.target === this.props.target && this.props.currentItemInactive ? ' pe-none' : '')}
                        item={item}
                        disabled={this.props.disabled || this.props.itemsDisabled || item.disabled}
                        onClick={this.onItemClick}
                        onDisabledClick={this.onDisabledItemClick}
                    >
                        <span>{OEFNStartSelectionModel.unpackLabel(item.label, this.props.strings)}</span>
                    </OEFNElement.Block>
                );
            });
        });

        return (
            <React.Fragment>
                {elements}
            </React.Fragment>
        );
    }

    onItemClick(id, sender) {
        if(this.props.onItemClick)  this.props.onItemClick(this, sender.props.item, id);
    }

    onDisabledItemClick(id, sender) {
        if(this.props.onDisabledItemClick)  this.props.onDisabledItemClick(this, sender.props.item, id);
    }
}

OEFNStartSelectionCategory.defaultProps = {
    disabled:               false,
    itemsDisabled:          false,
    currentItemInactive:    true,
    categoryLabel:          true
};

OEFNStartSelectionCategory.propTypes = {
    target:                 PropTypes.string,
    disabled:               PropTypes.bool,
    itemsDisabled:          PropTypes.bool,
    currentItemInactive:    PropTypes.bool,
    categoryLabel:          PropTypes.bool,
    category:               OEFNStartSelectionPropTypes.category,
    strings:                PropTypes.object,
    onItemClick:            PropTypes.func,
    onDisabledItemClick:    PropTypes.func
};